var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"kanbanmap_wrap"}},[_c('ul',{attrs:{"id":"lineTag"}},_vm._l((_vm.lines),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"dot",style:({background:_vm.color[index]})}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('div',{attrs:{"id":"kanbanmap"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4624a8da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/carlook/ecmap.vue
// module id = null
// module chunks = 